<script>
import { mapGetters } from 'vuex'
export default {
    props: {
        info: {
            type: Object,
            required: true
        },
        isClientLoggedIn: {
            type: Boolean,
            required: false, 
            default: false
        }
    },
    created () {
        this.$store.dispatch('countries/getCountries')
    },
    computed: {
        ...mapGetters({
            'getCountryByCode': 'countries/getByCode'
        }),
        zipCity () {
            return [this.info.zip, this.info.city].filter(val => val).join(' ')
        },
        zoneCountry () {
            return [this.info.zone, this.info.country ? this.getCountryByCode(this.info.country) : ''].filter(val => val).join(', ')
        }
    }
}
</script>

<template>
    <div class="form-group m-b-10">
        <label class="col-sm-3 control-label mb-0">
            {{ trans('online_booking.information') }}
        </label>
        <div class="col-sm-9" v-if="info">
            <div class="form-control-static">
                <span v-if="info.name">{{ info.name }}</span>
                <div v-if="!isClientLoggedIn">
                    <span v-if="info.address">{{ info.address}} <br/></span>
                    <span v-if="info.address_line_2">{{ info.address_line_2}} <br/></span>
                    <span v-if="zipCity">{{ zipCity }} <br/></span>
                    <span v-if="zoneCountry">{{ zoneCountry }} <br/></span>
                </div>
                <span v-if="info.email"><br>{{ info.email }}</span>
                <span v-if="info.phone"><br>{{ info.phone }}</span>
                <span v-if="info.dob"><br>{{ trans('client.date_of_birth') + ': ' + info.dob }}</span>
            </div>
        </div>
    </div>
</template>
